<template>
  <a-modal
    title="添加计划组织"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    okText="添加"
    @cancel="close"
    @ok="confirmBtn"
    :confirmLoading="confirmLoading"
  >
    <a-table
      :columns="columns"
      :loading="pageParams.tableLoading"
      :data-source="tableList"
      :row-selection="rowSelection"
      :pagination="false"
      row-key="organizationCode"
      :scroll="{ y: 230 }"
    >
      <!-- 筛选 -->
      <div
        slot="filterDropdown"
        slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
        class="p8"
      >
        <a-input
          :placeholder="`搜索 ${column.title}`"
          :value="selectedKeys[0]"
          class="search-tb1"
          @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
          @pressEnter="() => handleSearch(selectedKeys, column.dataIndex, confirm, 'page', 'queryParams')"
        />
        <a-button
          type="primary"
          icon="search"
          size="small"
          class="search-tb2"
          @click="() => handleSearch(selectedKeys, column.dataIndex, confirm, 'page', 'queryParams')"
        >搜索</a-button>
        <a-button size="small" class="w90" @click="() => handleReset(column.dataIndex, clearFilters, 'page', 'queryParams')">重置</a-button>
      </div>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record">
        <div :key="item.dataIndex">
          <span v-if="item.type === 'switch'">
            <a-switch :checked="record[item.dataIndex] === 'Y'" @change="statusTableOnChange(record, item.dataIndex)" />
          </span>
          <span v-else-if="item.type === 'tag'" class="table-line">
            <span>{{ text }}</span>
            <a-tag v-if="record.message" color="red" class="tag">{{ record.message }}</a-tag>
          </span>
          <span v-else>{{ text }}</span>
        </div>
      </template>
    </a-table>
    <!-- 底部分页按钮 -->
    <Page ref="page" :pageParams.sync="pageParams" @getList="getList" />
  </a-modal>
</template>

<script>
import { apiScpPlanMrpOrganizationsAdd } from '@/api/scp/planSetting/mrpPlanName'

export default {
  props: {},
  data () {
    return {
      pageParams: {
        automatic: false,
        pageUrl: '/scp/scpMrpOrganizations/list',
        tableLoading: false
      },
      queryParams: {
        organizationCode: "",
        organizationName: ""
      },
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [],
      columns1: [
        {
          title: '组织',
          dataIndex: 'organizationCode',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown', customRender: 'organizationCode' },
          type: 'tag'
        },
        {
          title: '组织名称',
          dataIndex: 'organizationName',
          align: 'center',
          scopedSlots: { filterDropdown: 'filterDropdown' }
        }
      ],
      columns2: [
        {
          title: '净WIP',
          dataIndex: 'considerWip',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'considerWip' },
          type: "switch"
        },
        {
          title: '净采购',
          dataIndex: 'considerPo',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'considerPo' },
          type: "switch"
        },
        {
          title: '净预留',
          dataIndex: 'considerReservations',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'considerReservations' },
          type: "switch"
        },
        {
          title: '计划安全库存',
          dataIndex: 'planSafetyStock',
          align: 'center',
          width: 130,
          scopedSlots: { customRender: 'planSafetyStock' },
          type: "switch"
        }
      ],
      tableList: [],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      detail: null
    }
  },
  created () {},
  methods: {
    show (val) {
      this.visible = true
      this.detail = val
      this.queryParams.planName = this.detail.planName

      if (val.planType === "102" || val.planType === "103") {
        this.columns = JSON.parse(JSON.stringify(this.columns1));
      } else {
        const arr1 = JSON.parse(JSON.stringify(this.columns1))
        const arr2 = JSON.parse(JSON.stringify(this.columns2))
        arr1.splice(2, 0, ...arr2);
        this.columns = arr1
      }

      this.$nextTick(() => {
        this.$refs.page.getFirstPage(this.queryParams)
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    /** 查询列表 */
    getList (data) {
      data.forEach(element => {
        element.considerWip = "Y"
        element.considerPo = "Y"
        element.considerReservations = "Y"
        element.planSafetyStock = "Y"
      });
      this.tableList = data
    },
    // 保存
    confirmBtn () {
      this.confirmLoading = true
      const arr = JSON.parse(JSON.stringify(this.selectedRows))
      arr.forEach(element => {
        element.planOrganization = element.organizationCode
        element.organizationCode = this.detail.organizationCode
        element.planName = this.detail.planName
      });
      apiScpPlanMrpOrganizationsAdd(arr).then(response => {
        if (response.code === 200) {
          if (response.data && response.data.length > 0) {
            const arr = JSON.parse(JSON.stringify(this.tableList))
            arr.forEach(element => {
              element.message = ""
            });
            response.data.forEach(element => {
              arr[Number(element.lineNum) - 1].message = element.message
            });
            this.tableList = arr
            this.$message.error(response.data[0].message)
            this.confirmLoading = false
            return
          }
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.queryParams = {
        organizationCode: "",
        organizationName: ""
      }
      this.tableList = []
    },
    statusTableOnChange (record, dataIndex) {
      record[dataIndex] = record[dataIndex] === 'Y' ? 'N' : 'Y'
    },
    // table 头筛选-搜索
    handleSearch (selectedKeys, dataIndex, confirm, refName, queryParamsName) {
      confirm();
      this[queryParamsName][dataIndex] = selectedKeys[0]
      this.$refs[refName].getFirstPage(this[queryParamsName])
    },
    // table 头筛选-重置
    handleReset (dataIndex, clearFilters, refName, queryParamsName) {
      clearFilters();
      this[queryParamsName][dataIndex] = ""
      this.$refs[refName].getFirstPage(this[queryParamsName])
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 170px;
}
input{
  width: 170px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.table-line{
  position: relative;
  .tag{
    position: absolute;
    left: 40px;
    bottom: -30px;
    z-index: 10000000;
  }
}
.p8 {
  padding: 8px;
}
.search-tb1 {
  width: 188px;
  margin-bottom: 8px;
  display: block;
}
.search-tb2 {
  width: 90px;
  margin-right: 8px
}
</style>
